import { validate as isValidUUID } from 'uuid';
import type { UpdateTeacherProfileParams } from '@/app/(teacher)/profile/_actions/types';
import type { TeacherProfileStore } from './TeacherProfileStore';

export default function teacherProfileToDB(teacherProfile: TeacherProfileStore): UpdateTeacherProfileParams {
  return {
    profile_image: teacherProfile.profileImage || null,
    profession_id: teacherProfile.selectedProfessionId as string,
    city: teacherProfile.city || null,
    state_province: teacherProfile.stateProvince || null,
    country_code: teacherProfile.countryCode || null,
    institutions: teacherProfile.getFormattedInstitutions(),
    grades: teacherProfile.selectedGrades.map((grade_id) => ({ grade_id })),
    subjects: teacherProfile.selectedSubjects.map((subjectId) =>
      isValidUUID(subjectId) ? { subject_id: subjectId } : { custom_name: subjectId },
    ),
    name: teacherProfile.fullName,
    student_friendly_name: teacherProfile.studentFriendlyName,
    profile_complete: teacherProfile.profileComplete,
  };
}
